import React from "react";
import styles from "./StatsSection.module.css";
import { FaTerminal } from "react-icons/fa6";
import { isSmallScreen } from "../../../utils/screen";
import { useTranslation } from "../../../hooks/useTranslation";

const StatsSection: React.FC = () => {
  const { t } = useTranslation();
  
  const stats = [
    { number: t("stats.item1.number"), label: t("stats.item1.label") },
    { number: t("stats.item2.number"), label: t("stats.item2.label") },
    { number: t("stats.item3.number"), label: t("stats.item3.label") },
    { number: t("stats.item4.number"), label: t("stats.item4.label") },
    { number: t("stats.item5.number"), label: t("stats.item5.label") },
    { number: t("stats.item6.number"), label: t("stats.item6.label") },
  ];

  return (
    <section className={styles.statsSection}>
      <div className={styles.leftContent}>
        <FaTerminal size={isSmallScreen() ? 44 : 54} />
        <div className={styles.textContainer}>
          <h2 className={styles.sectionTitle}>
            {t("stats.title")}
          </h2>
          <p className={styles.sectionSubtitle}>
            {t("stats.subtitle")}
          </p>
        </div>
      </div>

      <div className={styles.rightContent}>
        {stats.map((stat, index) => (
          <div className={styles.stat} key={index}>
            <p className={styles.statNumber}>{stat.number}</p>
            <p className={styles.statLabel}>{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;
